<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.67761 6.60199C4.9705 6.3091 5.44538 6.3091 5.73827 6.60199L9.00338 9.86711L12.2685 6.60199C12.5614 6.3091 13.0363 6.3091 13.3292 6.60199C13.6221 6.89489 13.6221 7.36976 13.3292 7.66265L9.53371 11.4581C9.24082 11.751 8.76595 11.751 8.47305 11.4581L4.67761 7.66265C4.38472 7.36976 4.38472 6.89489 4.67761 6.60199Z"
      fill="currentColor"
    />
  </svg>
</template>
